import tableOfContentsModel from './TableOfContents.model.json';
import { TableOfContentsProps } from '../TableOfContents.types';

export const tableOfContentsMockData = tableOfContentsModel;

export const tableOfContentsMockProps: TableOfContentsProps = {
  tableofcontents: tableOfContentsMockData,
};
